module.exports = __webpack_public_path__ + "static/media/sea-road-dark.819ad608.png";